module.exports = __webpack_public_path__ + "static/media/completado.7c1192ab.png";